var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "拆箱",
        "before-close": _vm.close,
        width: "600px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "p16" },
        [
          _c(
            "el-form",
            {
              ref: "unpackFormRef",
              attrs: {
                rules: _vm.formRules,
                model: _vm.formData,
                "label-width": "100px",
                size: "medium",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                },
              },
            },
            [
              _c("el-form-item", { attrs: { label: "商品" } }, [
                _vm._v(
                  " 【 " +
                    _vm._s(_vm.info.name) +
                    " ( ID： " +
                    _vm._s(_vm.info.id) +
                    " ) 】 "
                ),
              ]),
              _c("el-form-item", { attrs: { label: "换算数量" } }, [
                !!_vm.info.convertQty
                  ? _c("span", [_vm._v(_vm._s(_vm.info.convertQty))])
                  : _c("span", { staticClass: "text-danger" }, [
                      _vm._v("未设置，请前往商品处编辑！"),
                    ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "子商品" } },
                [
                  _vm.isChildExist
                    ? _c("el-row", [
                        _c("span", [
                          _vm._v(
                            "【 " +
                              _vm._s(
                                _vm.info.childGoodsName || _vm.info.childBarcode
                              ) +
                              " " +
                              _vm._s(
                                _vm.info.childGoodsId
                                  ? "( ID： " + _vm.info.childGoodsId + " )"
                                  : ""
                              ) +
                              " 】"
                          ),
                        ]),
                        _vm.isParentChildEqual
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v("子商品不能与商品相同！"),
                            ])
                          : _vm._e(),
                      ])
                    : _c("el-row", { staticClass: "text-danger" }, [
                        _vm._v("子商品不存在！"),
                      ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "拆箱数量", prop: "unpackQty" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, step: 1, precision: 0 },
                    model: {
                      value: _vm.formData.unpackQty,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "unpackQty", $$v)
                      },
                      expression: "formData.unpackQty",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.formData.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mb20", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.submitDisabled },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("更新")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }